import { Divider, ListItemText, MenuItem, Typography } from "@mui/material";
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";

import { CentralLoadingIndicator } from "../../../components";
import { GvCustomMenu } from "../../../styles/styledComponents";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import NullStateMessage from "../../../components/NullStateMessage/NullStateMessage";
import PaymentHistoryCardList from "../../../components/PaymentHistoryCardList/PaymentHistoryCardList";
import { getLastNYears } from "../../../utils/genericUtils";
import { useInvoice } from "../../../services/invoice-view/invoice-view.service";
import { useInvoicePDF } from "../../../services/invoice-view/Invoice-view-mutation";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { userActivityLogger } from "../../../utils/mixpanel";

const GvPaymentHistoryContainer = () => {
  // eslint-disable-next-line no-unused-vars
  const { loading, invoiceList } = useInvoice();
  const { getInvoicePDF, invoicePDFDetails, downloadloading } = useInvoicePDF();
  const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  // eslint-disable-next-line no-unused-vars
  const { petList } = usePetStore();

  const handleYearChange = (value: number) => {
    userActivityLogger(MIXPANEL_EVENTS.USER_CLICK_PAST_PAYMENT, { selected_year: value });
    setSelectedYear(value);
    handleClose();
  };

  const open = Boolean(anchorEl);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const yearsList = getLastNYears(5);

  const filterByYear = invoiceList?.items?.filter((item)=>new Date(item.date * 1000).getFullYear()===selectedYear && item.source == "ezyvet");

  const handleDownloadPDF = async (id: string) => {
    userActivityLogger(MIXPANEL_EVENTS.DOWNLOAD_INVOICE, { selected_year: selectedYear });
    getInvoicePDF(id);
  };

  useEffect(()=>{
    if (invoicePDFDetails?.success) {
      openPDF();
    }

    function openPDF() {
      window.open(invoicePDFDetails?.url);
    }

    return () =>{

    };
  }, [invoicePDFDetails?.url]);

  useEffect(() => {
    if (selectedYear) {
      userActivityLogger(MIXPANEL_EVENTS.PAYMENT_HISTORY, { selected_year: selectedYear });
    }
  }, []);

  return <>
    {loading ?
      <CentralLoadingIndicator message="Hold tight . . . we’re pulling up your payment history." /> :

      downloadloading ?
        <CentralLoadingIndicator message="Hold tight . . . we’re preparing your invoice for download." />:

        invoiceList?.items?.length?
          <div className="w-full h-full flex justify-center cursor-default">
            <div className={`flex flex-col items-center w-full ${filterByYear?.length ? "w-full max-w-[528px]" : ""} gap-3`}>

              <div className="flex justify-end w-full max-w-[528px]">
                <div className="flex gap-1 border border-gray-3 rounded-lg min-w-min items-center px-2 bg-white
        cursor-pointer" id="appointment-button" aria-haspopup="true"
                aria-controls={open ? "appointment-menu" : undefined}
                aria-expanded={open ? "true" : undefined} onClick={(e)=>handleClick(e)}>
                  <Typography variant="body1"> {selectedYear} </Typography>
                  <KeyboardArrowDownIcon/>
                </div>

                <GvCustomMenu autoFocus={false} transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  id="appointment-menu" anchorEl={anchorEl} open={open}
                  onClose={handleClose}
                  MenuListProps={{ "aria-labelledby": "appointment-button" }}>
                  {yearsList.map((year) => (
                    <div key={year}>
                      <MenuItem onClick={()=>handleYearChange(year)}>
                        <ListItemText>{year}</ListItemText>
                      </MenuItem>
                      <Divider className="w-full !m-0" />
                    </div>
                  ))}
                </GvCustomMenu>
              </div>

              { filterByYear?.length && petList?.length ?
                <PaymentHistoryCardList paymentDetailsList={filterByYear} handleInvoiceDownload={handleDownloadPDF}
                  petList={petList}/> :
                <div className="h-full w-full max-w-[528px]">
                  <NullStateMessage
                    message={`It looks like you don’t have any invoices for ${selectedYear}.
                          If this isn’t the case, please contact your local GoodVets hospital.`}
                    messageClass="text-gray-1"
                    imageSrc="/assets/icons/paymentHistryNullState.png"
                    imageHeight="12.5rem"
                  />
                </div>

              }
            </div>
          </div>:

          <div className="h-full">
            <NullStateMessage
              message="No Payment History"
              subMessage="There are no recorded payments on your account yet."
              imageSrc="/assets/icons/paymentHistryNullState.png"
            />
          </div>
    }

  </>;
};

export default GvPaymentHistoryContainer;
